export function strNormalize(str: string | number | boolean): string {
  return String(str)
    .normalize('NFD')
    .replace(/[^a-zA-Z0-9\s]/g, '');
}

export function resizeString(
  str: string,
  size: number | undefined = 50,
): string {
  if (str.length <= size) {
    return str;
  }
  return `${str.split('').splice(0, size).join('')}...`;
}

export function capitalize(str: string, lower = false): string {
  return (lower ? str.toLowerCase() : str).replace(
    /(?:^|\s|["'([{])+\S/g,
    match => match.toUpperCase(),
  );
}

export function stripTags(html: string): string {
  return html.replace(/(<([^>]+)>)/gi, '');
}
